import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

const updateOrder = (data: any): Promise<any> => {
  return axios.put(`orders/${data.orderId}`, data)
}

export function useUpdateOrder() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation(updateOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('proposal')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadAutentiqueSignedProposals')
      queryClient.invalidateQueries('loadHandSignedProposals')
      queryClient.clear()

      toast.success('Pedido atualizado com sucesso!')
      navigate('/orders')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível atualizar o pedido!')
    }
  })
}
